// ── src/pages/KycReviewPage.jsx ────────────────────────────────────────────
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import adminApi from '../api/adminApi';
import './KycReviewPage.css';

export default function KycReviewPage() {
  const { userId }  = useParams();      // e.g. /kyc-review/123
  const  navigate   = useNavigate();

  const [user ,   setUser ]   = useState(null);
  const [error,   setError]   = useState(null);
  const [loading, setLoading] = useState(true);

  /* ──────────────────────────────────────────────────────────
     1. Validate the route param & fetch user data **after**
        the first render.  No navigation inside render. */
  useEffect(() => {
    // If the route is wrong, redirect once *after* mount
    if (!userId) {
      navigate('/admin/dashboard', { replace: true });
      return;
    }

    // Abort‑controller so we don’t try to setState after unmount
    const ctrl = new AbortController();

    (async () => {
      try {
        const { data } = await adminApi.getUserById(userId, {
          signal: ctrl.signal
        });
        setUser(data);
      } catch (err) {
        if (ctrl.signal.aborted) return;       // silent abort
        const msg =
          err.response?.data?.message ||
          'Failed to fetch user details.';
        setError(msg);
      } finally {
        setLoading(false);
      }
    })();

    // cleanup
    return () => ctrl.abort();
  }, [userId, navigate]);

  /* ──────────────────────────────────────────────────────────
     2. UI states */
  if (loading)  return <div className="kyc-review-loading">Loading…</div>;
  if (error)    return <div className="kyc-review-error">{error}</div>;
  if (!user)    return null; // should not happen but keeps TS/IDE happy

  /* ──────────────────────────────────────────────────────────
     3. Happy path */
  return (
    <div className="kyc-review-container">
      <h2>KYC Review – {user.firstName} {user.lastName}</h2>

      <p><strong>Email:</strong> {user.email}</p>
      <p><strong>KYC status:</strong> {user.kycStatus}</p>
      <p>
        <strong>Submitted&nbsp;at:</strong>{' '}
        {user.kycSubmittedAt
          ? new Date(user.kycSubmittedAt).toLocaleString()
          : 'N/A'}
      </p>

      {/* … add more fields here if you like … */}

      <div className="actions">
        <button
          type="button"
          onClick={() => navigate('/admin/dashboard')}
        >
          ← Back to dashboard
        </button>
      </div>
    </div>
  );
}
